import React from 'react';

export const LaptopIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="laptopIconT">laptop icon</title>
            <desc id="laptopIconD">A vector illustration of a laptop icon</desc>
            <path
                d="M0.4 17.6C0.1792 17.6 0 17.7792 0 18C0 19.5088 1.0344 20.8 2.4 20.8H21.6C22.9656 20.8 24 19.5088 24 18C24 17.7792 23.8208 17.6 23.6 17.6H0.4ZM0.9344 18.4H23.0656C22.896 19.308 22.3312 20 21.6 20H2.4C1.6688 20 1.104 19.308 0.9344 18.4ZM4.4 4.8C3.7424 4.8 3.2 5.3424 3.2 6V16.4C3.2 16.6208 3.3792 16.8 3.6 16.8H20.4C20.6208 16.8 20.8 16.6208 20.8 16.4V6C20.8 5.3424 20.2576 4.8 19.6 4.8H4.4ZM4.4 5.6H19.6C19.8288 5.6 20 5.7712 20 6V16H4V6C4 5.7712 4.1712 5.6 4.4 5.6ZM3.6 3.2C2.4992 3.2 1.6 4.0992 1.6 5.2V16.4C1.592 16.9408 2.408 16.9408 2.4 16.4V5.2C2.4 4.528 2.928 4 3.6 4H20.4C21.072 4 21.6 4.528 21.6 5.2V16.4C21.592 16.9408 22.408 16.9408 22.4 16.4V5.2C22.4 4.0992 21.5008 3.2 20.4 3.2H3.6Z"
                fill="black"
            />
        </svg>
    );
};
